import { render, staticRenderFns } from "./GammaPartnerHubWidget.vue?vue&type=template&id=7c4a7654&scoped=true"
import script from "./GammaPartnerHubWidget.vue?vue&type=script&lang=ts"
export * from "./GammaPartnerHubWidget.vue?vue&type=script&lang=ts"
import style0 from "./GammaPartnerHubWidget.vue?vue&type=style&index=0&id=7c4a7654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4a7654",
  null
  
)

export default component.exports